import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { CommonDataService } from '../../../common/services/common-data.service';
import { GraphqlService } from '../../../common/services/graphql.service';
import { ValidationService } from '../../../common/services/validation.service';
import { constObj } from '../../../common/Constants/constants';
import { LoginService } from '../../../common/services/Login.service';
import { Router } from '@angular/router';
@Component({
  selector: 'app-contact-support',
  templateUrl: './contact-support.component.html',
  styleUrls: ['./contact-support.component.css']
})
export class ContactSupportComponent implements OnInit {

  @Output() myEvent = new EventEmitter<string>();
  HeadingLabel: string;
  SubHeadingLabel: string;
  emailLabel: string;
  emailConfirmationLabel: string;
  basicViewLabel: string;
  professionalViewLabel: string;
  submitLabel: string;
  textarealabel: string;
  contactEmailBody: string;
  contactEmailSubject: string;
  codtechEmailBody: string;
  codtechEmailSubject: string;
  siteKey: string = "";
  emailError: string;
  verifiedEmailError: string;
  emailMismatchError: string;
  emailBodyError: string;
  recaptcharesolved :boolean
  browserName: string;
  osName: string;

  isMailSentSuccessfully: boolean = false;

  remainingText: number = 4000;
  emailBodyChange(value: string) {
    this.remainingText = 4000 - value.length;
  }

  contactSupportForm = new FormGroup({
    contactSupportEmail: new FormControl(''),
    contactSupportEmailVerify: new FormControl(''),
    contactSupportEmailBody: new FormControl(''),
    emailMismatch: new FormControl('')
  });
  LoginPageURL: boolean = false;
  constructor(
    public commonDataService: CommonDataService,
    private graphQlService: GraphqlService,
    private validationService: ValidationService,
    private loginService: LoginService,
    private router: Router,
  ) { }

  ngOnInit(): void {
    this.LoginPageURL = this.router.url.includes("Login");
    const userBrowserDetails = window["userBrowserDetails"];
    this.browserName = userBrowserDetails.getBrowser().name + " " + userBrowserDetails.getBrowser().version;
    this.osName = userBrowserDetails.getOS().name + " " + userBrowserDetails.getOS().versionName;
    this.loginService.getSiteKey().subscribe(siteKey => { this.siteKey = siteKey.result; })
    this.commonDataService.showLoader.next(true);
    this.getContactSupportLabels();
  }
  public resolved(captchaResponse: string): void {
    this.recaptcharesolved = true;
    document.getElementById("submit").removeAttribute("disabled");
    document.getElementById("submit").classList.remove("btn-primary-disabled-basic");
    document.getElementById("submit").classList.add("btn-primary-basic", "cursor-pointer");
  }
  public errorrecap(): void {
    this.recaptcharesolved = false;
    document.getElementById("submit").setAttribute("disabled", "true");
    document.getElementById("submit").classList.add("btn-primary-disabled-basic");
    document.getElementById("submit").classList.remove("btn-primary-basic", "cursor-pointer");
  }

  getContactSupportLabels() {
    this.graphQlService.getContactSupportLabels().subscribe(data => {
      if (data != null) {
        let labels = data.content.data.labels;
        labels = labels.filter(x => x.key.trim());
        this.HeadingLabel = labels.filter(x => x.key == "contactSupport_headerGASB").map(y => y.value);
        this.SubHeadingLabel = labels.filter(x => x.key == "contactSupport_descriptionGASB").map(y => y.value);
        this.emailLabel = labels.filter(x => x.key == "contactSupport_enterEmail").map(y => y.value);
        this.emailConfirmationLabel = labels.filter(x => x.key == "contactSupport_verifyEmail").map(y => y.value);
        this.basicViewLabel = labels.filter(x => x.key == "contactSupport_basicView").map(y => y.value);
        this.professionalViewLabel = labels.filter(x => x.key == "contactSupport_professionalView").map(y => y.value);
        this.submitLabel = labels.filter(x => x.key == "contactsupport_buttonSubmit").map(y => y.value);
        this.textarealabel = labels.filter(x => x.key == "contactsupport_textarealabel").map(y => y.value);
        this.commonDataService.showLoader.next(false);
      }
      else {
        this.commonDataService.showLoader.next(false);
      }
    });
  }

  checkValidations() {
    let captcha = this.checkCaptcha();
    if (captcha || !this.LoginPageURL) {
      let emailCheck = this.checkEmail();
      let verifiedEmailCheck = this.checkVerifiedEmail();
      let emailMatchCheck = this.matchEmail();
      let emailBodyCheck = this.checkRequiredEmailBody();
      return (emailCheck && verifiedEmailCheck && emailMatchCheck && emailBodyCheck);
    } else {
      return (captcha );
    }
  }
  checkCaptcha() {
    return this.recaptcharesolved;
  }

  //checkRequiredSubscriptionType(): boolean {
  //  let subscriptionType = this.contactSupportForm.controls.contactSupportSubscriptionType.value;
  //  let isValid = this.validationService.validateRequiredField(subscriptionType);
  //  if (!isValid) {
  //    this.contactSupportForm.controls.contactSupportSubscriptionType.setErrors({ 'isEmpty': true });
  //    this.subscriptionTypeError = "Please select '" + this.subscriptionTypeLabel[0]?.replace(":", "") + ".'";
  //    this.contactSupportForm.controls.contactSupportSubscriptionType.markAsTouched();
  //  }
  //  else {
  //    this.contactSupportForm.controls.contactSupportSubscriptionType.setErrors(null);
  //    this.subscriptionTypeError = null;
  //  }
  //  return isValid;
  //}

  checkRequiredEmailBody(): boolean {
    let emailBody = this.contactSupportForm.controls.contactSupportEmailBody.value;
    let isValid = this.validationService.validateRequiredField(emailBody);
    if (!isValid) {
      this.contactSupportForm.controls.contactSupportEmailBody.setErrors({ 'isEmpty': true });
      this.emailBodyError = "Please enter a message before clicking 'Submit.'";
      this.contactSupportForm.controls.contactSupportEmailBody.markAsTouched();
    }
    else {
      this.contactSupportForm.controls.contactSupportEmailBody.setErrors(null);
      this.emailBodyError = null;
    }
    return isValid;
  }

  checkEmail(): boolean {
    let emailValid = true;
    let email = this.contactSupportForm.controls.contactSupportEmail;
    if (!this.validationService.validateRequiredField(email.value)) {
      email.setErrors({ 'required': true });
      this.emailError = this.emailLabel;
      email.markAsTouched();
      emailValid = false;
    }

    else if (!this.validationService.validateEmailformat(email.value)
      || !this.validationService.validateEmailfullformat(email.value)
      || !this.validationService.validateEmailspecialCharformat(email.value)
      || !this.validationService.validatemailpostionRegexformat(email.value)) {
      email.setErrors({ 'hasInvalidEmail': true });
      this.emailError = this.validationService.getErrorMessage('valid', "email address", null);
      email.markAsTouched();
      emailValid = false
    }

    if (emailValid) {
      email.setErrors(null);
    }

    return emailValid;
  }

  checkVerifiedEmail(): boolean {
    let emailValid = true;
    let email = this.contactSupportForm.controls.contactSupportEmailVerify;
    if (!this.validationService.validateRequiredField(email.value)) {
      email.setErrors({ 'required': true });
      this.verifiedEmailError = this.emailConfirmationLabel;
      email.markAsTouched();
      emailValid = false;
    }

    else if (!this.validationService.validateEmailformat(email.value)
    || !this.validationService.validateEmailfullformat(email.value)
    || !this.validationService.validateEmailspecialCharformat(email.value)
    || !this.validationService.validatemailpostionRegexformat(email.value)) {
      email.setErrors({ 'hasInvalidEmail': true });
      this.verifiedEmailError = this.validationService.getErrorMessage('valid', "email address", null);
      email.markAsTouched();
      emailValid = false
    }

    if (emailValid) {
      email.setErrors(null);
    }

    return emailValid;
  }

  matchEmail(): boolean {
    let email = this.contactSupportForm.controls.contactSupportEmail.value;
    let emailVerify = this.contactSupportForm.controls.contactSupportEmailVerify.value;

    let isValid = this.validationService.compareString(email, emailVerify);

    if (!isValid) {
      this.contactSupportForm.controls.emailMismatch.setErrors({ 'emailMismatch': true });
      this.emailMismatchError = "The email addresses entered do not match.";
      this.contactSupportForm.controls.contactSupportEmail.markAsTouched();
      this.contactSupportForm.controls.contactSupportEmailVerify.markAsTouched();
    }
    else {
      this.contactSupportForm.controls.emailMismatch.setErrors(null);
      this.emailMismatchError = null;
    }
    return isValid;
  }

  enterKey() {
    this.contactSupportSubmit();
  }

  closeOverlay() {
    this.myEvent.emit();
    this.commonDataService.showLoader.next(false);
  }

  contactSupportSubmit() {
    if (this.checkValidations()) {
      this.commonDataService.showLoader.next(true);
      this.graphQlService.getContactSupportLabels().subscribe(data1 => {
        if (data1 != null) {
          var labels = data1.content.data.labels
          labels = labels.filter(x => x.key.trim());
          this.contactEmailBody = labels.filter(x => x.key == "contactEmail_body").map(y => y.value);
          this.contactEmailSubject = labels.filter(x => x.key == "contactEmail_subject").map(y => y.value);
          this.codtechEmailBody = labels.filter(x => x.key == "contactEmailCodtech_body").map(y => y.value);
          this.codtechEmailSubject = labels.filter(x => x.key == "contactEmailCodtech_subject").map(y => y.value);
          const body = {
            contactEmailBody: this.contactEmailBody[0],
            contactEmailSubject: this.contactEmailSubject[0],
            codtechEmailBody: this.codtechEmailBody[0],
            codtechEmailSubject: this.codtechEmailSubject[0],
            userEmailID: this.contactSupportForm.controls.contactSupportEmail.value,
            userMessage: this.contactSupportForm.controls.contactSupportEmailBody.value,
            browser: this.browserName,
            OS: this.osName
          };
          this.graphQlService.SendContactSupportMail(body).subscribe(data => {
            if (data != null) {
              let obj;
              if (data.isEmailSent) {
                obj = {
                  type: 'success',
                  displayTime: 5000,
                  position: 'bottom',
                  message: constObj.contactSupportSuccess
                };

                this.isMailSentSuccessfully = true;

              }
              else {
                obj = {
                  type: 'fail',
                  displayTime: 5000,
                  position: 'bottom',
                  message: constObj.generalFeedbacemailFail
                }
              }
              this.commonDataService.notificationObject.next(obj);
              this.closeOverlay();
            }
            else {
              this.closeOverlay();
            }
          });
        }
        else {
          this.commonDataService.showLoader.next(true);
        }
      });
    }
  }

}
